let setUpConstants = function(module) {

  module.constant('PASSWORD_REGEX', new RegExp(/(\s?[a-zA-Z0-9]){6,30}/));
  module.constant('PHONE_REGEX', new RegExp(/^[0-9]{9}$/));
  module.constant('ROLES', {client: 'CLIENT', instalator: 'INSTALATOR'});
};

export default setUpConstants;


// WEBPACK FOOTER //
// ./src/commons/constants.js